const validate = {
  rules: {
    nome: {
      required: true,
    },
    imagem: {
      required: true,
    },
  },
  messages: {
    nome: "O nome é obrigatório.",
    imagem: "A imagem é obrigatória.",
  },
};

export default validate;
